import { addToChainAfter, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchSetProductFilters, RemoveAllFilters } from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { CustomHandlerWithResult } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ProductFiltersExtended } from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductListIsStockAvailableReducer";

type HandlerType = HandlerWithResult<
    {
        removeAll?: true;
    }, 
    ProductFiltersExtended
>;

export const RemoveIsStockedAtBranch: HandlerType = props => {
    props.result.isInStockAtBranch = undefined;
};

export const DispatchIsInStockFilter: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/IsStockAvailable/SetIsInStockAtBranch",
        data: props.result,
    });
};

addToChainAfter(
    chain as HandlerWithResult<{removeAll?: true;}, ProductFiltersExtended>[],
    RemoveAllFilters,
    RemoveIsStockedAtBranch as HandlerWithResult<{removeAll?: true;}, ProductFiltersExtended>
);

addToChainAfter(
    chain as HandlerWithResult<{removeAll?: true;}, ProductFiltersExtended>[],
    DispatchSetProductFilters,
    DispatchIsInStockFilter as HandlerWithResult<{removeAll?: true;}, ProductFiltersExtended>
);